<script setup>
const props = defineProps({
  text: Object,
  image: Object,
  switchBlocks: {
    type: Boolean,
  },
});
</script>

<template>
  <section class="l-container p-section">
    <div
      class="flex flex-wrap md:pt-[60px]"
      :class="
        text?.position === 'left'
          ? 'flex-col-reverse md:flex-row-reverse'
          : 'flex-col md:flex-row'
      "
    >
      <div class="w-full md:w-1/2"
      :class="!switchBlocks ? 'flex items-center justify-center' : ''">
        <picture v-if="image">
          <source
            v-if="image.type !== 'svg' && image?.url?.webp"
            :srcset="image?.url?.webp"
            type="image/webp"
          />
          <source
            v-if="image.type !== 'svg' && image.type !== 'png' && image?.url?.jpg"
            :srcset="image?.url?.jpg"
            type="image/jpeg"
          />
          <img
            v-if="image.type === 'jpg' && image?.url?.jpg"
            class="block w-full"
            :class="!switchBlocks ? 'max-h-[500px] object-contain' : ''"
            :src="image?.url?.jpg"
            :alt="image?.alt"
            :title="image?.title"
          />
          <img
            v-else-if="image.type === 'png' && image?.url?.png"
            class="block w-full"
            :class="!switchBlocks ? 'max-h-[500px] object-contain' : ''"
            :src="image?.url?.png"
            :alt="image?.alt"
            :title="image?.title"
          />
          <img
            v-else
            class="block w-full"
            :class="!switchBlocks ? 'max-h-[500px] object-contain' : ''"
            :src="image?.url?.original"
            :alt="image?.alt"
            :title="image?.title"
          />
        </picture>
      </div>
      <div
        class="relative w-full md:w-1/2 flex flex-wrap items-start"
        :class="[
          switchBlocks ? 'md:top-[-60px]' : 'top-0 flex items-center',
          switchBlocks
            ? (text?.position === 'left' ? 'md:right-[-60px]' : 'md:right-[60px]')
            : 'right-0'
        ]"      >
        <div
          v-if="text?.content"
          class="w-full"
          :class="switchBlocks ? ['p-block', text?.bg] : ''"
        >
          <div
            v-html="text?.content"
            class="prose"
            :class="text?.bg === 'bg-white' ? 'prose--black' : ''"
          ></div>
        </div>
      </div>
    </div>
  </section>
</template>

<style></style>
